<template>
  <div
    class="bg-white p-10 rounded-xl shadow-lg max-w-4xl mx-auto border border-gray-300"
  >
    <h1 class="text-3xl font-semibold text-black mb-10 border-b pb-4">
      Resposta do Funcionário: {{ employee.NomeFuncionario }}
    </h1>

    <div v-if="loading" class="text-center py-12">
      <svg
        class="animate-spin h-6 w-6 text-gray-600 mx-auto"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-opacity="0.25"
        ></circle>
        <path
          d="M4 12a8 8 0 0 1 8-8V4a10 10 0 0 0-10 10h2z"
          fill="currentColor"
        ></path>
      </svg>
      <p class="text-gray-600 mt-4 text-base">Carregando...</p>
    </div>

    <div v-else>
      <h2
        class="text-xl font-bold text-black mb-4 border-b border-gray-300 pb-2"
      >
        Perfil do Funcionário
      </h2>
      <div
        v-if="employee && Object.keys(employee).length > 0"
        class="space-y-2 text-gray-800"
      >
        <p><strong>Nome:</strong> {{ employee.NomeFuncionario }}</p>
        <p><strong>Email:</strong> {{ employee.Email }}</p>
        <p><strong>Cargo:</strong> {{ employee.Cargo }}</p>
        <p>
          <strong>Gestor Responsavel:</strong> {{ employee.GestorResponsavel }}
        </p>
      </div>
      <h2
        class="text-xl font-bold text-black mb-4 border-b border-gray-300 pb-2 mt-10"
      >
        Perfil da Empresa
      </h2>
      <div
        v-if="enterprise && Object.keys(enterprise).length > 0"
        class="space-y-2 text-gray-800"
      >
        <p><strong>Nome:</strong> {{ enterprise.NomeEmpresa }}</p>
        <p><strong>Email:</strong> {{ enterprise.Email }}</p>
        <p><strong>CNPJ:</strong> {{ enterprise.CNPJ }}</p>
        <p><strong>Telefone:</strong> {{ enterprise.Telefone }}</p>
        <p><strong>Endereço:</strong> {{ enterprise.Endereco }}</p>
      </div>

      <h2
        class="text-xl font-bold text-black mt-10 mb-4 border-b border-gray-300 pb-2"
      >
        Respostas
      </h2>
      <ul v-if="responses.length" class="space-y-6">
        <li
          v-for="(response, index) in responses"
          :key="index"
          class="bg-gray-50 p-5 rounded-lg border border-gray-200"
        >
          <div
            v-for="(question, qIndex) in response.Question"
            :key="qIndex"
            class="mb-2"
          >
            <p class="font-medium text-black">{{ question }}</p>
            <p class="text-sm text-gray-600">{{ response.Answers[qIndex] }}</p>
          </div>
        </li>
      </ul>

      <p v-else class="text-gray-600 text-center">
        Nenhuma resposta encontrada.
      </p>

      <div class="mt-10 text-right">
        <button
          @click="getResponsesByEmployeeId"
          class="px-6 py-2 bg-black text-white font-medium rounded hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-400 transition duration-150"
        >
          Atualizar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getEmployeeById } from '@/services/company/api.employees'
import { getEnterpriseById } from '@/services/company/api.enterprise'
import { getResponsesByEmployeeId } from '@/services/qa/api.responses'

export default {
  props: {
    EmployeeID: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      responses: [],
      employee: {},
      enterprise: {},
      loading: true,
    }
  },
  async mounted() {
    try {
      const response = await getResponsesByEmployeeId(
        this.EmployeeID || '67ef0ebba58223a5caedeb45'
      )
      if (Array.isArray(response)) {
        this.responses = response
      } else {
        console.error('No valid responses found:', response)
      }
      await this.getEmployeeById()
      await this.getEnterpriseById()
    } catch (error) {
      console.error('Error :', error)
    } finally {
      this.loading = false
    }
  },
  methods: {
    async getEnterpriseById() {
      try {
        const response = await getEnterpriseById(this.employee.EmpresaID)
        this.enterprise = response
      } catch (error) {
        console.error('Error fetching enterprise:', error)
      }
    },
    async getResponsesByEmployeeId() {
      try {
        const response = await getResponsesByEmployeeId(
          this.EmployeeID || '67ef0ebba58223a5caedeb45'
        )
        console.log('Responses:', response)
        this.responses = response
      } catch (error) {
        console.error('Error fetching responses:', error)
      }
    },
    async getEmployeeById() {
      try {
        const response = await getEmployeeById(
          this.EmployeeID || '67ef0ebba58223a5caedeb45'
        )
        console.log('Employee:', response)
        this.employee = response
      } catch (error) {
        console.error('Error fetching employee:', error)
      }
    },
  },
}
</script>
